export default __webpack_public_path__ + "static/media/VehicleInfo.a54a867c.svg";